import { render, staticRenderFns } from "./DetailApplication.vue?vue&type=template&id=7a778bfa&scoped=true"
import script from "./DetailApplication.vue?vue&type=script&lang=js"
export * from "./DetailApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a778bfa",
  null
  
)

export default component.exports